import React, { Component } from "react";
import { Table } from "react-bootstrap";
import Moment from "react-moment";

class TableAkreditasi extends Component {
  render() {
    let DataProdi = this.props.dataProdi;
    console.log("DataProdi");
    console.log(DataProdi);
    let data = [];
    let i = 0;
    let nowYear = new Date().getFullYear() - 1;
    // for (var key in dataProdi) {
    //     if (dataProdi.hasOwnProperty(key)) {
    //         data[i] = dataProdi[key][dataProdi[key].length-1][nowYear];
    //     }
    //     i++;
    // }
    let statussp = [];
    statussp["A"] = "Aktif";
    statussp["B"] = "Alih Bentuk";
    statussp["H"] = "Tutup";
    statussp["K"] = "Alih Kelola";
    // statussp["H"] = "Pembinaan";
    console.log(statussp);

    let tableAkre = [];
    (DataProdi || []).map((list, i) => {
      tableAkre.push(
        <>
          <tr>
            <td className="text-center">{i + 1}</td>
            <td className="text-center">{list.kode_prodi}</td>
            <td>{list.nm_prodi}</td>
            <td className="text-center">{statussp[list.stat_prodi]}</td>
            <td className="text-center">{list.nm_jenj_didik}</td>
            <td className="text-center">
              {list.akred_prodi !== "null" ? list.akred_prodi : "-"}
            </td>
            <td className="text-center">
              {list.tgl_sk_akred_prodi === "null" ? (
                "-"
              ) : (
                <Moment format="DD/MM/YYYY" date={list.tgl_sk_akred_prodi} />
              )}
            </td>
            <td className="text-center">
              {list.rasio === "null" ? "-" : "1:" + list.rasio}
            </td>

            {/* <td className="text-center">-</td>
                        
                        <td className="text-center">Rp. - </td> */}
            {/* <td className="text-center">-</td> */}
          </tr>
        </>
      );
    });

    return (
      <Table responsive style={{ overflow: "overlay" }}>
        <thead
          className="text-white text-uppercase"
          style={{ backgroundColor: "#3047ad" }}
        >
          <tr>
            <th
              className="text-center"
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                verticalAlign: "middle",
                width: "3%",
              }}
            >
              No
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                verticalAlign: "middle",
                width: "10%",
              }}
            >
              Kode Prodi
            </th>
            <th
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                verticalAlign: "middle",
                width: "27%",
              }}
            >
              Nama Program Studi
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                verticalAlign: "middle",
                width: "5%",
              }}
            >
              Status
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                verticalAlign: "middle",
                width: "7%",
              }}
            >
              Jenjang
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                verticalAlign: "middle",
                width: "8%",
              }}
            >
              Akreditasi
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                verticalAlign: "middle",
                width: "10%",
              }}
            >
              Tanggal SK Akreditasi
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                verticalAlign: "middle",
                width: "10%",
              }}
            >
              Rasio Dosen/Mahasiswa
            </th>
            {/* <th className="text-center" className="text-center" style={{fontSize:'12px', textTransform: 'uppercase', verticalAlign: 'middle', width:'10%'}}>
                            Pengelola SPMI
                        </th>
                        <th className="text-center" className="text-center" style={{fontSize:'12px', textTransform: 'uppercase', verticalAlign: 'middle', width:'10%'}}>
                            Anggaran SPMI
                        </th> */}
            {/* <th className="text-center" className="text-center" style={{fontSize:'12px', textTransform: 'uppercase', verticalAlign: 'middle', width:'10%'}}>
                            Rasio Dosen
                        </th> */}
          </tr>
        </thead>
        <tbody>{tableAkre}</tbody>
      </Table>
    );
  }
}
export default TableAkreditasi;
